import { Dialog } from 'primereact/dialog'
import React, { useEffect, useState } from 'react'
import classes from './ViewInfoModal.module.scss'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import {
  GridColumnViewInfoModelList,
  viewInfoGridColumns,
} from '../../../../project-management/data/view-info-grid-columns'
import ProjectService from '../../../../../services/ProjectService'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface ViewInfoModalProps {
  onHide: () => void
  visible: boolean
  e2eprojectLineId: string
}

const ViewInfoModal = ({ onHide, visible, e2eprojectLineId }: ViewInfoModalProps) => {
  const [columns, setColumns] = useState(viewInfoGridColumns)
  const [data, setData] = useState([])
  const [orderLineDescription, setOrderlineDescription] = useState()
  const [psn, setPsn] = useState()
  const [flexProject, setFlexProject] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      if (!visible || !e2eprojectLineId) return
      setIsLoading(true)

      try {
        const response = await ProjectService.getOrderlineModels(e2eprojectLineId)

        if (response.isSuccess) {
          const {
            orderLineDescription,
            partySiteNumber,
            flexProjectName,
            e2EProjectLineModelInfoModels,
          } = response.data
          setOrderlineDescription(orderLineDescription)
          setPsn(partySiteNumber)
          setFlexProject(flexProjectName)
          setData(e2EProjectLineModelInfoModels || [])
        }
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }

    if (e2eprojectLineId) {
      fetchData()
    }
  }, [visible, e2eprojectLineId])

  const footer = () => (
    <>
      <hr className={classes['modal-footer-hr']} />

      <div className={`${classes['dialog-footer']} ${classes['center-items']}`}>
        <button className={`${classes['dialog-close-btn']} ul-button -medium`} onClick={onHide}>
          CLOSE
        </button>
      </div>
    </>
  )

  const tableColumnHeader = (col: GridColumnViewInfoModelList) => {
    return (
      <div>
        <span title={col.value}>{col.value}</span>
      </div>
    )
  }

  const renderDynamicColumns = () =>
    columns.map((col: GridColumnViewInfoModelList) => (
      <Column
        columnKey={col.id}
        key={col.value}
        field={col.id}
        header={tableColumnHeader(col)}
        frozen={col.isFrozen}
        alignFrozen="left"
        hidden={!col.isShown}
        style={{ width: col.width, flexBasis: col.width }}
        sortable={false}
      />
    ))

  const emptyMessageTemplate = () => {
    return (
      <span className={classes['empty-message']}>
        No models are associated for this order line.
      </span>
    )
  }

  const loadingIndicator = (
    <div className="text-center w-100">
      <FontAwesomeIcon icon={faSpinner} spin={true} />
    </div>
  )

  return (
    <Dialog
      closable={true}
      draggable={false}
      resizable={false}
      header={'Model Info'}
      footer={footer}
      onHide={() => onHide && onHide()}
      visible={visible} // update
      style={{ width: '930px', height: '600px' }}
      className={classes['custom-dialog']}
    >
      <hr className="modal-header-hr" />

      {isLoading && <div className={classes['indicator-container']}>{loadingIndicator}</div>}

      {!isLoading && (
        <div className={classes['modal__body']}>
          <div className={classes['info-header']}>
            <p>
              <strong>Order Line Number:</strong>{' '}
              <span title={orderLineDescription}>{orderLineDescription}</span>
            </p>
            <p>
              <strong>Model PSN:</strong> {psn}
            </p>
          </div>
          <p>
            <strong>FLEX Project:</strong> {flexProject}
          </p>
          <DataTable
            value={data}
            className={`${classes['info-table']} ${data.length === 0 ? classes['empty-table'] : ''}`}
            showGridlines
            emptyMessage={emptyMessageTemplate()}
          >
            {renderDynamicColumns()}
          </DataTable>
        </div>
      )}
    </Dialog>
  )
}

export default ViewInfoModal
